import React from 'react';
import Img from 'gatsby-image'
import styles from './Hero.module.scss';

const Hero = (props) => (
<div className={ `${props.className ? `${props.className}` : ''}${styles.Hero ? styles.Hero && props.className ? ` ${styles.Hero}` : styles.Hero : '' }` } style={ props.style }>
    <div className={styles.Hero__top}>
        <div className={styles.Hero__title}>
            <h1>{props.title}</h1>
        </div>
        <img className={styles.Hero__strokes} src="/images/green-strokes.png" alt="green strokes" />
        {
            props.image && !props.src &&
            <div className={styles.Hero__Image}>
                <Img sizes={props.image.sizes} alt={props.image.title} />
                <p>{props.image.title}</p>
            </div>
        }
        {
            props.src && !props.static &&
            <div className={styles.Hero__Image}>
                <img src={ props.src.file.url } alt={ props.src.title } />
            </div>
        }
        {
            props.src && props.static &&
            <div className={styles.Hero__Image}>
                <img src={ props.src } alt="" />
            </div>
        }
    </div>
</div>
)

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Program/Hero/index.js